export default __webpack_public_path__ + "static/media/Sleep-Logo.3343fa62.jpeg";